import {Injectable} from "@angular/core";
import {StringUtils} from "./framework/utils/string-utils";

export class Session {
    private _sessionMap: Map<string, any> = new Map<string, any>();

    constructor(public sessionId: string) {
    }

    get sessionMap(): Map<string, any> {
        return this._sessionMap;
    }
}

@Injectable()
export class SessionService {

    private sessions: Map<string, Session> = new Map<string, Session>();

    createSession(sessionId?: string): Session {
        const sessionHolder: Session = new Session(sessionId || StringUtils.uuid());
        this.sessions.set(sessionHolder.sessionId, sessionHolder);

        return sessionHolder;
    }

    deleteSession(sessionId: string): void {
        this.sessions.delete(sessionId);
    }

    getSession(sessionId: string): Session {
        return this.sessions.get(sessionId);
    }
}
